// iConnect — Hot water system type archive filter (taxonomy-hot_water_system_type.php)
//
// A household chip moves the lime marker to it, fades the current cards
// out, swaps in the systems that suit that household size (data-household on
// each card, from the HWS Selector rules) and fades them in, without movement. The
// section height tweens between the old and new rows so the page doesn't jump.
// Every system is already on the page, so this runs in the browser.

import gsap from "../../js/gsap/gsap.min.js";

(function () {

const filter = document.querySelector(".hwst-filter");
if (!filter) return;

const chips  = [...filter.querySelectorAll(".hwst-filter__chip")];
const marker = filter.querySelector(".hwst-filter__marker");
const grid   = document.querySelector(".hwst-archive__grid");
const box    = grid.parentElement;   // height tweens here, not on the grid, so the cards keep their size
const cards  = [...grid.children];
const count  = document.querySelector("#hwst-count");
const motion = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

let busy = false;

function show(household) {
    cards.forEach(card => {
        card.hidden = household !== "all" && !card.dataset.household.split(" ").includes(household);
    });
    const shown = cards.filter(card => !card.hidden);
    count.textContent = shown.length;
    return shown;
}

async function select(chip) {
    if (busy || chip.getAttribute("aria-pressed") === "true") return;

    chips.forEach(el => el.setAttribute("aria-pressed", el === chip));
    chip.append(marker);

    if (!motion) {
        show(chip.dataset.household);
        return;
    }

    busy = true;

    const from = box.offsetHeight;
    await gsap.to(cards.filter(card => !card.hidden), { opacity: 0, duration: 0.25, stagger: 0.02 });

    const shown = show(chip.dataset.household);
    gsap.fromTo(box,
        { height: from, overflow: "hidden" },
        { height: box.offsetHeight, duration: 0.5, ease: "power2.inOut", clearProps: "height,overflow" }
    );
    await gsap.fromTo(shown,
        { opacity: 0 },
        { opacity: 1, duration: 0.6, ease: "power2.out", stagger: 0.06, clearProps: "opacity" }
    );

    busy = false;
}

chips.forEach(chip => chip.addEventListener("click", () => select(chip)));

})();
